<template>
  <vl-grid v-vl-spacer:top.medium>
    <vl-column width="12" width-xs="12">
      <div class="vl-u-spacer--small">
        <vl-title tag-name="h4"> {{ $t('systemtable.dataConnection.title') }} </vl-title>
      </div>
    </vl-column>
    <vl-column width="12" width-xs="12">
      <vl-data-table-extended
        v-if="items"
        :data="items"
        :columns="columnMap"
        :meta="metaData"
        mod-zebra
        @column-clicked="columnClicked"
      >
      </vl-data-table-extended>
    </vl-column>
  </vl-grid>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { ColumnDefExtended } from '@/components/vl-data-table-extended/types';
import { RowData } from '@tanstack/vue-table';
import { DataConnectionDto } from '@/api/backoffice/clients';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const metaData = computed(() => {
  return {
    serverside: false
  };
});

const props = defineProps<{
  items: DataConnectionDto[];
}>();

const columnMap = computed((): ColumnDefExtended<RowData>[] => {
  return [
    {
      accessorKey: 'id',
      header: t('systemtable.dataConnection.list.table.header.id'),
      enableSorting: true,
      size: 5,
      link: true
    },
    {
      accessorKey: 'code',
      header: t('systemtable.dataConnection.list.table.header.code'),
      enableSorting: true,
      size: 30,
      link: true
    },
    {
      accessorKey: 'label',
      header: t('systemtable.dataConnection.list.table.header.label'),
      enableSorting: true,
      size: 30,
      link: true
    },
    {
      accessorKey: 'isReadOnly',
      header: t('systemtable.dataConnection.list.table.header.isReadOnly'),
      enableSorting: true,
      size: 10,
      link: true,
      cell: (props) => {
        return props?.getValue() ? t('general.yes') : t('general.no');
      }
    },
    {
      accessorKey: 'busyCount',
      header: t('systemtable.dataConnection.list.table.header.busyCount'),
      enableSorting: true,
      size: 10,
      link: true
    },
    {
      accessorKey: 'switch',
      header: t('systemtable.dataConnection.list.table.header.switch'),
      enableSorting: true,
      size: 10,
      link: true,
      cell: (props) => {
        return props?.getValue() ? t('general.yes') : t('general.no');
      }
    },
    {
      accessorKey: 'isSwitching',
      header: t('systemtable.dataConnection.list.table.header.isSwitching'),
      enableSorting: true,
      size: 10,
      link: true,
      cell: (props) => {
        return props?.getValue() ? t('general.yes') : t('general.no');
      }
    }
  ];
});

const columnClicked = (evt: { key: string; direction: string }) => {
  // TODO
};
</script>
<style lang="scss" scoped>
.vl-grid {
  flex-grow: 1;
}
</style>
